export const sapLangMap: Record<string, string> = {
  en: 'E',
  fi: 'F',
  cs: 'C',
}

export function getSapLocalizedText(texts: Record<string, string> | undefined, locale: string): string {
  if (!texts) return '-'
  
  const sapLang = sapLangMap[locale]
  
  return texts[sapLang] ?? texts['E'] ?? Object.values(texts)[0] ?? '-'
}
